(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("_"));
	else if(typeof define === 'function' && define.amd)
		define(["_"], factory);
	else if(typeof exports === 'object')
		exports["MobxReactFormValidatorVJF"] = factory(require("_"));
	else
		root["MobxReactFormValidatorVJF"] = factory(root["_"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__479__) => {
return 